import * as actions from "../actionTypes"
import { MY_VIEWS_TAB } from "../../pages/services/modelEditDashboardServices"

const initialState = {
  value: MY_VIEWS_TAB,
}

export default function modelEditDashboardTab(state = initialState, action) {
  switch (action.type) {
    case actions.SET_MODEL_EDIT_DASHBOARD_TAB: {
      return {
        ...state,
        value: action.payload.value,
      }
    }

    default:
      return state
  }
}
